import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import i18next from 'i18next';
import { hasValue } from '@famly/stat_ts-utils_has-value';
import translate from 'signin-app/helpers/translate';
import * as GoHomeWithActions from 'signin-app/go-home-with/actions';
import * as GoHomeWithSelectors from 'signin-app/go-home-with/selectors';
import * as PinSelectors from 'signin-app/login/selectors';
import { UserOverview } from 'signin-app/components/user-overview';
import useTypedSelector from 'signin-app/components/hooks/use-typed-selector';
import { Spinner } from '@famly/mf_feedback_spinner';
import { Stack } from '@famly/mf_layout_stack';
import * as Selectors from './selectors';
const composePickupNameAndTime = (name, time) => {
    if (hasValue(name) && hasValue(time)) {
        return `${name}, ${time}`;
    }
    else if (hasValue(name)) {
        return name;
    }
    return null;
};
export const ChildOverview = ({ child, limitedData }) => {
    const childName = limitedData ? child.name.firstName : child.name.fullName;
    const subText = child.goHomeWithChildId || child.pickupRelationId ? translate('goingHomeWithAnotherChild') : '';
    const isPinApp = useTypedSelector(PinSelectors.isPinApp);
    const isFetching = useTypedSelector(state => GoHomeWithSelectors.isFetching(state));
    const pickupPersonName = useTypedSelector(state => Selectors.pickupFullName(state, {
        child,
        childId: child.id,
    }));
    const pickupTime = useTypedSelector(state => Selectors.pickupTime(state, {
        childId: child.id,
    }));
    React.useEffect(() => {
        if (child && isPinApp) {
            GoHomeWithActions.fetchGoHomeWithChildren.dispatch(child.id);
        }
    }, [child, isPinApp]);
    if (!child) {
        return null;
    }
    if (isFetching) {
        return (_jsx(Stack, { justifyContent: "center", marginY: 6, children: _jsx(Spinner, { size: 32, "aria-label": i18next.t($ => $.react.components.loading.spinner.translations.json.loadingAriaLabel) }) }));
    }
    return (_jsx(UserOverview, { image: child.image.large, name: childName, subText: subText, subTextBold: composePickupNameAndTime(pickupPersonName, pickupTime) }));
};
